module.exports = __webpack_public_path__ + "static/home1-products-by-category-hot-categories-b6cb6646efd032e7be06371e781d27c0.png";